import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import { useMediaQuery } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { isMobileOnly } from 'react-device-detect';

import TPButton from 'components/TP-UI/TPButton';
import TPGrid from 'components/TP-UI/TPGrid';
import TPTypography from 'components/TP-UI/TPTypography';
import { ACCOUNT_PLANS } from 'constants/accountPlans';

import useStyles from './styles';

const BenefitsSection = (props) => {
  const classes = useStyles();
  const lgBreakpoint = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const { accountPlan, benefits, buttonText, onAccountPlanSelect, title } = props;

  return (
    <TPGrid container direction="column" item key={title} spacing={3}>
      <TPGrid item>
        <TPTypography variant="h5">{title}</TPTypography>
      </TPGrid>
      <TPGrid
        container
        item
        direction="column"
        spacing={2}
        justifyContent="space-between"
        className={classes.benefits}>
        {Array.isArray(benefits) &&
          benefits.map((item, index) => (
            <TPGrid container item key={String(index)} spacing={2} wrap="nowrap">
              <TPGrid item>
                {item.benefit ? (
                  <CheckCircleOutlineIcon fontSize="small" />
                ) : (
                  <HighlightOffOutlinedIcon fontSize="small" />
                )}
              </TPGrid>
              <TPGrid item>
                <TPTypography className={classes.benefitText}>{item.text}</TPTypography>
              </TPGrid>
            </TPGrid>
          ))}
      </TPGrid>
      <TPGrid container item justifyContent={lgBreakpoint ? 'center' : 'flex-end'}>
        <TPGrid item>
          <TPButton
            fullWidth={isMobileOnly}
            onClick={() => onAccountPlanSelect(accountPlan)}
            primary
            size="large">
            {buttonText}
          </TPButton>
        </TPGrid>
      </TPGrid>
    </TPGrid>
  );
};

BenefitsSection.propTypes = {
  accountPlan: PropTypes.oneOf([ACCOUNT_PLANS.PRO, ACCOUNT_PLANS.RETAIL]),
  benefits: PropTypes.arrayOf(PropTypes.string),
  buttonText: PropTypes.string,
  onAccountPlanSelect: PropTypes.func,
  title: PropTypes.string,
};

export default BenefitsSection;
